import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DOCUMENT } from '../constants/documentTheme';
import PartnerTripAddOns from './PartnerTripAddOns';

/**
 * Group Add-ons tab: every add-on here is shared with the whole group.
 * An add-on for one traveler is created from that traveler's client itinerary.
 *
 * @param {{ groupTripId: number, travelers: Array<{ tripId: number, label: string }>, isActive?: boolean }} props
 */
const PartnerGroupAddOns = ({ groupTripId, travelers = [], isActive = true }) => {
  const { t } = useTranslation();

  return (
    <Box data-testid="partner-group-addons">
      <Typography sx={{ fontSize: 14, color: DOCUMENT.ink3, mb: 2 }}>
        {t('partnerAddons.groupIntro')}
      </Typography>
      <PartnerTripAddOns
        tripId={groupTripId}
        isActive={isActive}
        forGroup
        actionsDisabled={travelers.length === 0}
      />
    </Box>
  );
};

export default PartnerGroupAddOns;
